/**
 * Portal Type Enum.
 *
 * Represents the different portal types in the Case Manager application.
 * Used throughout the application to distinguish between Cases and Investigations contexts.
 */
export enum PortalType {
  Cases = 'cases',
  Investigations = 'investigations',
}
